<div class="container">
  <div class="user-list mt-3 mb-3" *ngIf="userNotifications.length > 0">
    <table class="table table-striped table-responsive-lg">
      <thead>
      <tr>
        <th scope="col" class="text-center">#</th>
        <th scope="col" class="text-center">Type</th>
        <th scope="col" class="text-center">User Email</th>
        <th scope="col" class="text-center">User Phone</th>
        <th scope="col" class="text-center">Caption</th>
        <th scope="col" class="text-center">Message</th>
        <th scope="col" class="text-center">Target</th>
        <th scope="col" class="text-center">Sent</th>
        <th scope="col" class="text-center">Created</th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let notification of userNotifications | paginate : {
                  itemsPerPage: pageSize,
                  currentPage: pageNumber,
                  totalItems: totalElements
                };
          let i = index">
        <td class="text-center">{{ notification.id }}</td>
        <td class="text-center">{{ notification.type }}</td>
        <td class="text-center">{{ notification.user.email }}</td>
        <td class="text-center">{{ notification.user.phone }}</td>
        <td>{{ notification.caption }}</td>
        <td>{{ notification.message }}</td>
        <td class="text-center">{{ notification.target }}</td>
        <td class="text-center">
          <ng-container *ngIf="notification.sentDate">
            {{ notification.sentDate | date:'dd.MM.yyyy HH:mm:ss' }}
          </ng-container>
          <ng-container *ngIf="!notification.sentDate">
            <button type="button" class="btn btn-default send-button" disabled>
              <i class="fa fa-paper-plane"></i>Send
            </button>
          </ng-container>
        </td>
        <td class="text-center">{{ notification.createdDate | date:'dd.MM.yyyy HH:mm:ss' }}</td>
      </tr>
      </tbody>
    </table>
  </div>
  <div class="mt-3 mb-3" *ngIf="userNotifications.length == 0">
    No content here
  </div>
  <div class="row justify-content-center">
    <div class="col-md-auto">
      <pagination-controls
        previousLabel="Prev"
        nextLabel="Next"
        responsive="true"
        (pageChange)="handlePageChange($event)"></pagination-controls>
    </div>
    <div class="col-md-auto">
      Items per page:
      <select (change)="handlePageSizeChange($event)">
        <option *ngFor="let size of pageSizes" [ngValue]="size">
          {{ size }}
        </option>
      </select>
    </div>
    <div class="col-md-auto">
      <div>{{ getMinLimit() }}-{{ getMaxLimit() }} of {{ totalElements }} items</div>
    </div>
  </div>
</div>
